import { render, staticRenderFns } from "./recycleGameBalance.vue?vue&type=template&id=b89f518e"
import script from "./recycleGameBalance.vue?vue&type=script&lang=js"
export * from "./recycleGameBalance.vue?vue&type=script&lang=js"
import style0 from "./recycleGameBalance.vue?vue&type=style&index=0&id=b89f518e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports